export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const ENTITY_FIRST_NAME = "Velocity";

export const ENTITY_LAST_NAME = "Neural";

export const ENTITY_FULL_NAME = "VelocityNeural";
